import type { LoadingField } from '../../../../shared/utils/loading-field';

export class TitleAttribute {
  readonly value: LoadingField | string;

  constructor(value: LoadingField | string) {
    this.value = value;
  }
}
